module.exports = __webpack_public_path__ + "static/media/yogi-unsubscribe.df33bdfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unsubscribe-success/yogi-unsubscribe.png
// module id = 2165
// module chunks = 0